import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=b24df824&scoped=true"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=b24df824&prod&lang=css"
import style1 from "./SectionCard.vue?vue&type=style&index=1&id=b24df824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24df824",
  null
  
)

export default component.exports